import React, { Component } from 'react';

class Details extends Component {
	clicked() {
		this.props.clicked(this.props.row);
	}
	checked() {
		this.props.checked(this.props.row);
	}
	render() {
		var checked = false;
		if(this.props.row.checked) checked = true;

		var src = "/images/0.jpg";
		if(this.props.row.hasimage) src = "/images/"+this.props.row.id+".jpg";

		return (
			<div className="details">
				<img src={src} alt={ this.props.row.title } />

				<div className="details-row">
					<label className="check">
					  <input type="checkbox" checked={checked} onChange={this.checked.bind(this)}/>
					  <div className="box"></div>
					</label>

					<span className="row-inner">
						{ this.props.row.title }
					</span>
				</div>
				<div className="details-breadcrumbs">{this.props.bread}</div>
				<div className="details-summary" dangerouslySetInnerHTML={{__html:this.props.row.desc}} />
			</div>
		);
	}


}



export default Details;



// WEBPACK FOOTER //
// ./src/Details.js